import { render, staticRenderFns } from "./viewBOLET.vue?vue&type=template&id=48bf5380&scoped=true"
import script from "./viewBOLET.vue?vue&type=script&lang=js"
export * from "./viewBOLET.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bf5380",
  null
  
)

export default component.exports